import vtkCutter from './Cutter';

export default {
  vtkCutter,
};
